<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-warning
				span.fa.fa-info-circle.mr-2
				| Cierre de mes
				button.close(@click="cerrar") &times;
			.card-body
				.alert.alert-warning
					| <b>Importante</b>: Antes de proceder al cierre del mes, asegúrate de que todos los registros son correctos y están completos, ya que una vez se cierre, ya no podrán modificarse registros ni añadir nuevos

				.form-group
					label
						b Usuario
					input-query.form-control(
						inputClass="form-control"
						v-if="!cierre.UsuarioID"
						placeholder="Busca un usuario"
						@selected="setUsuario($event)"
						:realtime="true"
						url="gestion-jornada/php/api/queryUsuarios.php"
					)
					.input-group(v-else)
						input.form-control(:value="UsuarioNombre", disabled="true")
						.input-group-append(v-if="permisos.gestion_jornada_editarTodos")
							button.btn.btn-danger(@click="cierre.UsuarioID = null")
								span.fa.fa-trash

				.form-group
					label
						b Mes
					datepicker(
						v-model="fecha"
						:bootstrap-styling="true"
						minimum-view="month"
						format="MMMM, yyyy"
						:language="$dateLang"
					)
			.card-footer
				button.btn.btn-primary(@click="cerrarMes()")
					span.fa.fa-check.mr-2
					| Cerrar mes
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
	data () {
		return {
			fecha: null,
			cierre: {
				UsuarioID: null,
				Mes: null
			},
			UsuarioNombre: null
		}
	},
	created () {
		this.cierre.UsuarioID = this.usuario.ID
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	methods: {
		setUsuario (e) {
			this.cierre.UsuarioID = e.datos.ID
			this.UsuarioNombre = e.datos.nombre + ' ' + e.datos.apellidos
		},
		cerrarMes () {
			if (!this.cierre.UsuarioID) {
				this.$error('Error', 'Debes seleccionar el usuario')
				return
			}
			if (!this.fecha) {
				this.$error('Error', 'Debes seleccionar el mes')
				return
			} else {
				this.cierre.Mes = this.$moment(this.fecha).format('YYYY-MM-DD')
			}
			axios.post('gestion-jornada/php/api/cerrarMes.php', this.cierre)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Cierre completo',
						mensaje: 'Se ha cerrado el mes correctamente'
					})
					this.cerrar()
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/informes/cierre.vue